export default function TableOfContents({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav 
      aria-label="Indholdsfortegnelse" 
      className="my-8 p-4 bg-[#FBF3DA] border border-[#E4E1D8] rounded-[4px] text-[15px]"
    >
      <div className="font-semibold text-[#2E3A46] uppercase tracking-wider text-[12px] mb-2 font-mono">
        Indhold på siden
      </div>
      <ol className="list-decimal list-inside space-y-1.5 text-[#2E3A46] m-0 p-0">
        {items.map((item, idx) => (
          <li key={idx} className="leading-snug">
            <a 
              href={`#${item.id}`} 
              className="text-[#1A1C1F] hover:text-[#B58200] hover:underline underline-offset-2 transition-colors"
            >
              {item.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
